// frontend/src/components/MlExperiment/MlExperimentDecision.tsx

import React from 'react';

interface Props {
  analysis: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const MlExperimentDecision: React.FC<Props> = ({ analysis }) => {
  // isApproved é usado APENAS para estética (cor/ícone).
  // O valor de `decision` é exibido cru logo abaixo.
  const isApproved = analysis.decision === 'APPROVED';

  return (
    <div style={{
      background: isApproved
        ? 'rgba(102, 187, 106, 0.05)'
        : 'rgba(239, 83, 80, 0.05)',
      borderRadius: '12px',
      padding: '20px',
      border: `1px solid ${isApproved ? '#66bb6a' : '#ef5350'}`,
      marginBottom: '24px'
    }}>
      {/* Identificação da execução */}
      <div style={{ marginBottom: '16px', paddingBottom: '12px', borderBottom: '1px solid #1a4a7a' }}>
        <div style={{ fontSize: '15px', fontWeight: 600, color: '#e0e0e0' }}>
          {renderValue(analysis.dataset_name)}
        </div>
        <div style={{ fontSize: '11px', color: '#8899aa', fontFamily: 'monospace', marginTop: '2px' }}>
          trace_id: {renderValue(analysis.trace_id)}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{ fontSize: '32px' }}>{isApproved ? '✅' : '❌'}</span>
        <div>
          <div style={{
            fontSize: '20px',
            fontWeight: 600,
            color: isApproved ? '#66bb6a' : '#ef5350'
          }}>
            {renderValue(analysis.decision)}
          </div>
          <div style={{ fontSize: '14px', color: '#8899aa', marginTop: '4px' }}>
            {renderValue(analysis.reason)}
          </div>
          {analysis.model_name && (
            <div style={{ fontSize: '13px', color: '#4fc3f7', marginTop: '4px' }}>
              🧠 Modelo: {renderValue(analysis.model_name)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};